import supports from '../lib/supports.js';
import {gsap} from 'gsap';

const setupObserver = (element) => {
  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        // Nav is in view on screen
        // hide fixed nav
        gsap.to('.section-nav.is-fixed', {
          duration: 0.3,
          y: '-100%',
        });
        // show site header
        gsap.to('.site-header', {
          duration: 0.3,
          y: 0,
        });
      } else if (e.intersectionRatio < 1) {
        // Nav is out of view and on top
        // show fixed nav
        if (e.boundingClientRect.top < e.intersectionRect.top) {
          gsap.to('.section-nav.is-fixed', {
            duration: 0.3,
            y: 0,
          });
          // hide site header
          gsap.to('.site-header', {
            duration: 0.3,
            y: '-100%',
          });
        } else {
          // Nav is out of view and on bottom
          // hide fixed nav
          gsap.to('.section-nav.is-fixed', {
            duration: 0.3,
            y: '-100%',
          });
          // show site header
          gsap.to('.site-header', {
            duration: 0.3,
            y: 0,
          });
        }
      }
    }
  );

  observer.observe(element);
};

const cloneNav = (element) => {
  const subNav = element.querySelector('[data-element="section-nav"]');
  const subNavClone = subNav.cloneNode(true);

  const fixedNav = document.createElement('div');
  fixedNav.classList.add('section-nav', 'bg-midnight', 'is-fixed');

  fixedNav.append(subNavClone);
  document.body.append(fixedNav);
};

const sectionNav = {
  init() {
    const element = document.querySelector('[data-module="sticky-nav"]');

    if (element && supports.intersectionObserver) {
      setupObserver(element);
      cloneNav(element);
    }
  },
};

export default sectionNav;
